'use client';

/*
 * Documentation:
 * Switch — https://app.subframe.com/6fc7f5fbb098/library?component=Switch_7a464794-9ea9-4040-b1de-5bfb2ce599d9
 */
import { c as _c } from "react/compiler-runtime";
import React from 'react';
import * as SubframeCore from '@subframe/core';
import * as SubframeUtils from '../utils';
interface ThumbProps extends React.ComponentProps<typeof SubframeCore.Switch.Thumb> {
  className?: string;
}
const Thumb = React.forwardRef<HTMLDivElement, ThumbProps>(function Thumb(t0, ref) {
  const $ = _c(11);
  let className;
  let otherProps;
  if ($[0] !== t0) {
    ({
      className,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = otherProps;
  } else {
    className = $[1];
    otherProps = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = SubframeUtils.twClassNames("flex h-3.5 w-3.5 flex-col items-start gap-2 rounded-full bg-white shadow-sm", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== ref || $[6] !== t1) {
    t2 = <div className={t1} ref={ref} />;
    $[5] = ref;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== otherProps || $[9] !== t2) {
    t3 = <SubframeCore.Switch.Thumb asChild={true} {...otherProps}>{t2}</SubframeCore.Switch.Thumb>;
    $[8] = otherProps;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
});
interface SwitchRootProps extends React.ComponentProps<typeof SubframeCore.Switch.Root> {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  className?: string;
}
const SwitchRoot = React.forwardRef<HTMLDivElement, SwitchRootProps>(function SwitchRoot(t0, ref) {
  const $ = _c(14);
  let className;
  let otherProps;
  let t1;
  if ($[0] !== t0) {
    ({
      checked: t1,
      className,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = otherProps;
    $[3] = t1;
  } else {
    className = $[1];
    otherProps = $[2];
    t1 = $[3];
  }
  const checked = t1 === undefined ? false : t1;
  let t2;
  if ($[4] !== className) {
    t2 = SubframeUtils.twClassNames("group/7a464794 aria-[checked=true]:border-brand-600 aria-[checked=true]:bg-brand-600 focus-visible:ring-brand-600/10 flex h-5 w-8 cursor-pointer flex-col items-start justify-center gap-2 rounded-full border border-solid border-neutral-200 bg-neutral-200 px-0.5 py-0.5 transition-all focus:outline-none focus-visible:ring-4 aria-[checked=true]:border aria-[checked=true]:border-solid", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Thumb />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== ref || $[8] !== t2) {
    t4 = <div className={t2} ref={ref}>{t3}</div>;
    $[7] = ref;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== checked || $[11] !== otherProps || $[12] !== t4) {
    t5 = <SubframeCore.Switch.Root checked={checked} asChild={true} {...otherProps}>{t4}</SubframeCore.Switch.Root>;
    $[10] = checked;
    $[11] = otherProps;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
});
export const Switch = Object.assign(SwitchRoot, {
  Thumb
});